<template>
  <div class="tablePage">
    <el-table
      v-loading="loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      stripe
      :header-cell-style="headCellStyle"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column
        v-if="isSys"
        prop="sceneName"
        :label="$t('public.table_scope')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="gasCode"
        :label="$t('public.table_code')"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <DeviceCode :device="row">
            <template #icon="{device}">
              <i
                v-icon:theme="['gasTypeConvert', device.type]"
                v-if="!$slots.icon"
              ></i>
            </template>
            <template #name="{device}">
              <el-popover placement="top-start" width="auto" trigger="hover">
                <v-popoer :rowData="row" :typeWay="typeWay" />
                <span
                  slot="reference"
                  :class="{
                    bolder: device.status === ENUM_SENSOR_STATUS.OFFLINE
                  }"
                >
                  {{ device.gasCode }}
                </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>

      <!--  架构与监测点类型只有已绑定 停止使用存在 -->
      <!--            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />-->
      <!-- 除了未确认都存在 -->
      <el-table-column
        prop="gatewayName"
        :label="$t('device.forward_gateway')"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <span style="cursor: pointer" @click="gatwayDetail(row.gatewayId)">
            {{ row.gatewayName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="probeValue"
        :label="$t('device.current_probe_value')"
        show-overflow-tooltip
        width="250"
      >
        <template #default="{ row }">
          <div class="temp-class" v-if="isSHowProbeValueFn(row)">
            <span class="t-h-time">{{
              generJsonFn1(row.probeValue, 'time')
            }}</span>

            <!-- 要获取监测区间--只有二氧化碳气体有 -->
            <el-popover
              v-if="row.type === 6"
              :popper-class="'popperClass'"
              placement="top"
              title=""
              width="200"
              trigger="hover"
            >
              <div class="tip-class">
                <template v-if="probeCozCache[row.gasCode]">
                  <div class="tip-name-class">
                    {{
                      probeCozCache[row.gasCode] &&
                        probeCozCache[row.gasCode].name
                    }}
                  </div>
                  <div class="tip-content-class">
                    {{
                      probeCozCache[row.gasCode] &&
                        probeCozCache[row.gasCode].min
                    }}%vol ~
                    {{
                      probeCozCache[row.gasCode] &&
                        probeCozCache[row.gasCode].max
                    }}%vol
                  </div>
                </template>
                <template v-else>
                  <div
                    style="height: 50px;line-height: 50px"
                    class="uk-text-center tip-content-class"
                  >
                    {{$t('public.no_monitoring_interval_set')}}
                  </div>
                </template>
              </div>
              <div
                slot="reference"
                class="t-h-val"
                :class="classFn(row, 'coz')"
                @mouseover="onProbeMouseOver(row, 'coz')"
                :title="$t('public.jump_to_history')"
                @click="$emit('historyFn', row, 'temp')"
              >
                {{ generJsonFn1(row.probeValue, 'coz') }}
              </div>
            </el-popover>
            <div
                v-else
                class="t-h-val"
                :title="$t('public.jump_to_history')"
                @click="$emit('historyFn', row, 'temp')"
              >
                {{ generJsonFn1(row.probeValue, 'gas') }}
              </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="carrierName"
        :label="$t('public.table_carrier')"
        width="250px"
      >
        <template #default="{ row }">
          <CardSwipper :key="Math.random()" :list="[row]">
            <template #title="{item}">
              {{ item.structureName }}
            </template>
            <template #default="{item}">
              <div class="uk-flex">
                <div style="width: 30px" class="bd-r uk-flex uk-flex-center">
                  <i
                    class="uk-margin-remove"
                    @click="carrierDetailFn(row)"
                    style="margin-right: 5px; cursor: pointer"
                    v-icon="['carrierTypeConvert', row.carrierType]"
                  ></i>
                </div>
                <div class="uk-flex-1">
                  {{ item.carrierName }}
                </div>
              </div>
            </template>
          </CardSwipper>
        </template>
      </el-table-column>
      <!--            <el-table-column prop="description" :label="$t('public.table_desc')" show-overflow-tooltip />-->
      <el-table-column
        prop="optare"
        fixed="right"
        :label="$t('public.table_operation')"
        width="130"
        align="center"
      >
        <template #default="{ row }">
          <template v-for="item in optareBtn">
            <el-button
              type="text"
              size="small"
              v-if="item.id === 2 ? getTabs(row.type).length : true"
              :key="item.id"
              :title="$t(item.title)"
              :icon="item.icon"
              @click="handle(item.method, row)"
            ></el-button>
          </template>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 监测点详情 -->
    <MonitorDialog
      :visible.sync="dialogVisible"
      :carrier-info="carrierDetail"
    ></MonitorDialog>
    <GatewayDialog
      :visible.sync="gatewayVisible"
      :gateway-id="gatewayId"
    ></GatewayDialog>
  </div>
</template>
<script>
import popover from '../components/Popover.vue'
import { carrierDetail } from '@/api/modules/carrier.js'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'
import { getIsSys } from '@/utils/permission'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import GatewayDialog from '@/pages/equipment/publicCom/GatewayDialog.vue'
import { getProbe } from '@/api/modules/public'
import { _throttle } from '@/utils/common'
import { getTabs } from '@/pages/equipment/sensor/components/sensor/cionfig/tabsController'

export default {
  name: 'Table',
  components: {
    GatewayDialog,
    DeviceCode,
    CardSwipper,
    'v-popoer': popover,
    MonitorDialog
  },
  props: ['loading', 'tableData'],
  computed: {
    i18n () {
      return this.$i18n.locale
    },
    isSys () {
      return getIsSys()
    },
    ENUM_SENSOR_STATUS: () => ENUM_DEVICE_STATUS
  },
  watch: {
    tableData () {
      this.probeCozCache = {}
      this.probeHumCache = {}
    }
  },
  data () {
    return {
      // 鼠标移动到探测值上时 有缓存则请求缓存 无缓存的话去请求  以tag作为key
      probeCozCache: {},
      probeHumCache: {},
      tableHeight: '100%',
      gatewayVisible: false,
      gatewayId: 0,
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 3,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
      ],
      /** 数据库获取的类型 */
      // CarrierTypeArray: [],
      /** 定义基础icon跟后台给的数据进行匹配 */
      carrierIconArray: [
        {
          type: 1,
          i18n: 'carrier.1',
          icon: 'iconfont icon-weibolu-xian'
        },
        {
          type: 2,
          i18n: 'carrier.2',
          icon: 'iconfont icon-bingxiang'
        },
        {
          type: 3,
          i18n: 'carrier.3',
          icon: 'iconfont icon-9lengku'
        },
        {
          type: 4,
          i18n: 'carrier.4',
          icon: 'iconfont icon-9lengku'
        }
      ],
      dialogVisible: false,
      carrierDetail: null,
      typeWay: 'bind'
    }
  },
  methods: {
    getTabs,
    // 鼠标移动到探测值时(要获取监测区间--只有二氧化碳气体有)
    onProbeMouseOver: _throttle(function (row, type) {
      const probeCache = this.probeCozCache 

      if (probeCache[row.gasCode]) {
        return
      }

      getProbe(row.gasCode, type).then(({ result }) => {
        if (result) {
          this.$set(probeCache, row.gasCode, result)
        }
      })
    }, 100),
    handleSelectionChange (arg) {
      this.$emit('choozeTable', arg)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    /** 数据状态 */
    styleFn (row) {
      if (row.status === 1) {
        return {
          color: '#65cea7',
          'font-weight': 'bold',
          cursor: 'pointer'
        }
      } else {
        return {
          color: 'red',
          cursor: 'pointer'
        }
      }
    },
    /**
     *
     * @param {*匹配字段} key
     * @param {*数组} array
     * @param {*返回数据} str
     */
    /** json转换 */
    generJsonFn1 (sample_value, s) {
      if (!sample_value) return
      let str = ' '
      const { gas, coz } = JSON.parse(sample_value)
      if (!gas && !coz) return
      // hum 湿度 temp 温度
      if (s === 'gas') {
        // str = gas.val + this.unit.temp.name
        str = gas.val + gas.unit
      }else if(s === 'coz'){
        str = coz.val + "%vol"
      } else {
        if(gas){
          str = this.$timetransition(gas.time)
        }else if(coz){
          str = this.$timetransition(coz.time)
        }
      }

      return str
    },
    /** 查找监测点详情 */
    carrierDetailFn (row) {
      this.dialogVisible = true
      carrierDetail(row.carrierType, row.carrierId).then(({ result }) => {
        result.mac = row.gatewayMac
        this.carrierDetail = result
      })
    },
    /** 根据id获取监测点关联的网关信息 */
    gatwayDetail (id) {
      this.gatewayVisible = true
      this.gatewayId = id
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 决策是否有探测值
    disabledFn (row, type) {
      const probeCache =
        type === 'temp' ? this.probeCozCache : this.probeHumCache
      if (probeCache[row.tagId]) {
        return false
      } else {
        return true
      }

      let flag = true
      if (!row.probeValue) return flag

      if (text === 'temp') {
        const { temp } = JSON.parse(row.probeValue)
        if (!temp) return
        // 按照需求所有的都需要显示区间 不做温区判断  无区间才不进行展示
        // flag = !(temp.val > row.maxTemp || temp.val < row.minTemp)
        flag = !row.tempRange
      } else {
        const { hum } = JSON.parse(row.probeValue)
        if (!hum) return
        // flag = !(hum.val > row.maxHum || hum.val < row.minHum)
        flag = !row.humRange
      }
      return flag
    },
    classFn (row, text) {
      if (!row.probeValue) return

      let className = ''
      const { coz } = JSON.parse(row.probeValue)
      if (!coz) return
      className =
        coz.val > row.max
          ? 'higher-range-bg'
          : coz.val < row.min
            ? 'lower-range-bg'
            : ''

      return className
      // const { hum } = JSON.parse(probe_value)
    },
    // 校准图标hover字样内容
    contentFn(row){
      if(row.calibrationType === 1){
        return this.$t('device.calibration_expiration') + ':' + this.$timetransition(row.calibrationExpireTime, 'Y-M-D')
      }
      if(row.calibrationType === 0){
        return $t('device.no_calibration')
      }
      return $t('device.no_set_calibration')
    },
    isSHowProbeValueFn(row){
      if(row.type === 6){
        return JSON.parse(row.probeValue).coz ? true : false
      }else{
        return JSON.parse(row.probeValue).gas ? true : false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
  height: calc(100% - 60px);

  .temp-class, .hum-class {
    height: 26px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .t-h-time {
      flex: 3;
      text-align: center;
      background-color: var(--primary-color);
      color: #FFFFFF;
      font-size: 12px;
      border: 1px solid var(--primary-color);
      border-right: none;
      border-radius: 2px 0px 0px 2px;
    }

    .t-h-val {
      cursor: pointer;
      width: 80px;
      font-size: 12px;
      text-align: center;
      box-sizing: border-box;
      border: 1px solid var(--primary-color);
      border-left: none;
      border-radius: 0px 2px 2px 0px;
    }
  }
}

.span-class {
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 10px;
}

.tip-class {
  .tip-name-class, .tip-content-class {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: var(--primary-color);
    color: #FFFFFF;
  }

  .tip-content-class {
    background-color: #FFFFFF;
    color: var(--primary-color);
  }
}

</style>
